import React, { useEffect, useState } from "react";
import styles from "./holiday-leave-tabs.module.css";
import SVGIcon from "../../../../constants/SVGIcon";
import CustomButton from "../../../../common/custom-button/custom-button";
import { Select, Space, Tabs } from "antd";
import { getEventsList } from "../../../../services/dashboard";
import { toast } from "react-toastify";
import {
  filterLeaveByDate,
  leaveTypeList,
} from "../../../../constants/common";
import { downloadHolidayList } from "../../../../services/holiday_leave";
import AddEditNewHoliday from "../add-edit-new-holiday/add-edit-new-holiday";
import LeaveRequestView from "../leave-request-view/leave-request-view";
import HolidayMainView from "../holiday-main-view/holiday-main-view";
import CustomSelect from "../../../../common/input/custom-select/custom-select";

const HolidayLeaveTabs = () => {
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("1");
  const [activeView, setActiveView] = useState("calendar");
  const [holidayList, setHolidayList] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editDetails, setEditDetails] = useState({});
  const [selectedLeaveType, setSelectedLeaveType] = useState("");
  const [selectedFilterBydate, setSelectedFilterBydate] = useState("");
  const [overviewStatistics, setOverviewStatistics] = useState({});

  useEffect(() => {
    if (leaveTypeList?.length && !selectedLeaveType) {
      const first = leaveTypeList[0].value;
      setSelectedLeaveType(first);
      handleChangeLeaveType(first);
    }
  }, [leaveTypeList, selectedLeaveType]);

  useEffect(() => {
    if (filterLeaveByDate?.length && !selectedFilterBydate) {
      const first = filterLeaveByDate[0].value;
      setSelectedFilterBydate(first);
      handleChangeFilterBydate(first);
    }
  }, [filterLeaveByDate, selectedFilterBydate]);

  useEffect(() => {
    fetchHolidayData();
  }, []);

  const handleChangeLeaveType = (value) => {
    setSelectedLeaveType(value);
  };

  const handleChangeFilterBydate = (value) => {
    setSelectedFilterBydate(value);
  };

  const getStyle = (isActive) => ({
    backgroundColor: "#fff",
    color: isActive ? "#39B54A" : "#888888",
    border: `1px solid ${isActive ? "#39B54A" : "#888888"}`,
  });

  const fetchHolidayData = async () => {
    try {
      setLoading(true);
      const resp = await getEventsList({});
      setOverviewStatistics(resp?.data?.summary);
      setHolidayList(resp?.data?.data || []);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error("Error Retrieving Stats");
    } finally {
      setLoading(false);
    }
  };

  const handleEditHoliday = (data) => {
    setEditDetails(data);
    setOpenDrawer(true);
  };

  const items = [
    {
      key: "1",
      label: "Holiday Calendar",
      children: (
        <HolidayMainView
          activeView={activeView}
          onEditHoliday={handleEditHoliday}
          overviewStatistics={overviewStatistics}
          holidayList={holidayList}
          loading={loading}
          fetchHolidayData={fetchHolidayData}
        />
      ),
    },
    {
      key: "2",
      label: "Leave Requests",
      children: (
        <LeaveRequestView
          leaveType={selectedLeaveType}
          filterData={selectedFilterBydate}
        />
      ),
    },
  ];

  const holidayActions = (
    <Space className={styles.actions}>
      <div className={styles.firstDiv}>
        <CustomButton
          title={
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              Export Holiday CSV
              <SVGIcon
                name="vector-icon"
                width="13"
                height="16"
                className="anticon"
                stroke="none"
                fill="#39B54A"
              />
            </div>
          }
          size="large"
          style={{
            backgroundColor: "#39B54A1A",
            color: "#39B54A",
            border: "none",
          }}
          onClick={() => handleExportCSV()}
        />
        <CustomButton
          title="List View"
          size="large"
          icon={
            <SVGIcon
              name="list-icon"
              width="22"
              height="22"
              className="anticon"
              stroke={activeView === "list" ? "#39B54A" : "#888888"}
            />
          }
          style={getStyle(activeView === "list")}
          onClick={() => setActiveView("list")}
        />
      </div>
      <div className={styles.firstDiv}>
        <CustomButton
          title="Calendar View"
          size="large"
          icon={
            <SVGIcon
              name="calendar-icon"
              width="22"
              height="22"
              className="anticon"
              stroke={activeView === "calendar" ? "#39B54A" : "#888888"}
            />
          }
          style={getStyle(activeView === "calendar")}
          onClick={() => setActiveView("calendar")}
        />
        <CustomButton
          title="New Holiday"
          size="large"
          icon={
            <SVGIcon
              name="add-icon"
              width="24"
              height="24"
              className="anticon"
              stroke="#FFF"
            />
          }
          onClick={() => handleAddHoliday()}
        />
      </div>
    </Space>
  );

  const leaveActions = (
    <Space className={styles.actions}>
      <CustomSelect
        style={{ minWidth: "150px" }}
        id="leave_type"
        placeholder="Select Leaves"
        size="large"
        value={selectedLeaveType}
        onChange={handleChangeLeaveType}
      >
        {leaveTypeList?.map((item, index) => (
          <Select.Option key={index} value={item?.value}>
            {item?.label}
          </Select.Option>
        ))}
      </CustomSelect>
      <CustomSelect
        style={{ minWidth: "150px" }}
        id="latest_date"
        placeholder="Select"
        size="large"
        value={selectedFilterBydate}
        onChange={handleChangeFilterBydate}
      >
        {filterLeaveByDate?.map((item, index) => (
          <Select.Option key={index} value={item?.value}>
            {item?.label}
          </Select.Option>
        ))}
      </CustomSelect>
    </Space>
  );

  const handleAddHoliday = () => {
    setOpenDrawer(true);
  };

  const handleOnClose = () => {
    setEditDetails({});
    setOpenDrawer(false);
  };

  const handleExportCSV = async () => {
    if (holidayList?.length > 0) {
      try {
        const params = { export: "csv" };
        const url = await downloadHolidayList(params);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "holiday-list.csv");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Download failed", error);
      }
    } else toast.error("No data in exam list.");
  };

  return (
    <div className={styles.main_view}>
      <>
        <div className={styles.tab_actions_mobile}>
          {" "}
          {selectedTab === "1" ? holidayActions : leaveActions}
        </div>

        <Tabs
          defaultActiveKey="1"
          items={items}
          tabBarStyle={{ borderBottom: "none" }}
          onChange={(activeKey) => {
            setSelectedTab(activeKey);
          }}
          tabBarExtraContent={
            selectedTab === "1" ? holidayActions : leaveActions
          }
        />
      </>
      <AddEditNewHoliday
        open={openDrawer}
        onClose={handleOnClose}
        data={editDetails}
        onSuccess={fetchHolidayData}
      />
    </div>
  );
};

export default HolidayLeaveTabs;
